import MatchedMap from 'utilities/src/matchedMap';
import { ButtonBGEnum } from '../../../types/_bg';

const buttonClassesMap = new MatchedMap([
  [
    ButtonBGEnum.Light,
    'px-4 border-2 rounded-lg box-border bg-transparent text-site-neutrals-900 focus:shadow-ring active:shadow-none',
  ],
  [
    ButtonBGEnum.Dark,
    'px-4 border-2 rounded-lg box-border bg-transparent text-site-neutrals-0 focus:shadow-ring active:shadow-none',
  ],
]);

const buttonHoverClassesMap = new MatchedMap([
  [ButtonBGEnum.Light, 'hover:text-site-neutrals-0'],
  [ButtonBGEnum.Dark, ''],
]);

const buttonDisabledClassesMap = new MatchedMap([
  [
    ButtonBGEnum.Light,
    'disabled:bg-site-neutrals-200 disabled:border-site-neutrals-200 disabled:text-site-neutrals-50',
  ],
  [ButtonBGEnum.Dark, 'disabled:border-site-neutrals-500'],
]);

const buttonSiteSecondaryClasses = [buttonClassesMap, buttonHoverClassesMap, buttonDisabledClassesMap];

export default buttonSiteSecondaryClasses;
